import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";
import * as THREE from "three";

export class loadModel {

    loader;
    dracoLoader;
    mainObject;
    clock;
    bBox;//包围盒
    rayMesh = [];
    removeMesh = [];
    meshPosition = {};
    meshPositions = [];
    actions=[];
    autoAnm = true;
    autoAnimation = [];
    time;
    out;
    mainMesh = [];
    constructor() {
        this.clock = new THREE.Clock();
        this.loader = new GLTFLoader();
        this.dracoLoader = new DRACOLoader();
        this.dracoLoader.setDecoderPath(`${process.env.BASE_URL}tools/`);
        this.loader.setDRACOLoader(this.dracoLoader);
    }

    loadModel(name, hdr, addScene, loaded) {
        //let count = 0;
        let self = this;
        self.bBox = new THREE.Box3();
        self.loader.load(name, object => {
            object.scene.traverse((child) => {
                if (child.isMesh) {
                    self.pushHideMesh(child);
                    child.material.envMap = hdr;
                    child.material.envMapIntensity = 1.5;
                    child.material.side = THREE.DoubleSide;
                    if (child instanceof THREE.Mesh) {
                        if (child.material.map) child.material.map.dispose();
                        child.material.dispose();
                        child.geometry.dispose();
                        child.remove();
                    } else if (child.material) {
                        child.material.dispose();
                        child.remove();
                    }

                }
            });
            self.mainObject = object;
            const bBox = this.bBox.clone().setFromObject(self.mainObject.scene);
            const height = bBox.max.y - bBox.min.y;
            const dist = height / (2 * Math.tan((60 * Math.PI) / 360));
            self.mainObject.scene.scale.set(4 / dist, 4 / dist, 4 / dist);
            addScene(self.mainObject.scene);
            self.animater();
        },xhr=>{
            loaded(Math.floor(xhr.loaded/xhr.total*100));
        });
    }

    actions = [];
    isPaly = false;

    animater() {
        const animations = this.mainObject.animations;
        if (animations && animations.length) {
            this.mixer = new THREE.AnimationMixer(this.mainObject.scene);
            for (let i = 0; i < animations.length; i++) {
                const animation = animations[i];
                //console.log(animation.tracks.splice(1, 1));
                const action = this.mixer.clipAction(animation);
                action.time = 0;
                animation.duration = 3.3;
                this.autoAnimation.push(animation);
                action.loop = THREE.LoopRepeat;
                action.clampWhenFinished = false;
                this.actions.push(action);
                action && action.play();
            }
        }
    }

    reset(enable){
        let self = this;
        if(enable){
            for (let i = 0; i < self.actions.length; i++) {
                self.actions[i].time = 0;
                self.autoAnimation[i].duration =0.6;
            }
        }else {
            for (let i = 0; i < self.actions.length; i++) {
                self.actions[i].time = 0.9;
                self.autoAnimation[i].duration = 3.3;
            }
        }
        if(self.time==null){
            self.time = setInterval(function () {
                for (let i = 0; i < self.actions.length; i++) {
                    self.actions[i].time = 0.9;
                    self.autoAnimation[i].duration = 3.3;
                }
            },2400);
        }
        if(enable){
            for (let i = 0; i < self.actions.length; i++) {
                self.actions[i].time = 0;
                self.autoAnimation[i].duration = 3.3;
            }
            clearInterval(self.time);
            self.time = null;
            self.stop();
        }
    }

    autoDisassemble(auto,restore){
        let self = this;
        self.autoAnm = false;
        if(auto){
            restore(false);
            self.reset(true);
            self.play(1);
        }else{
            restore(false);
            self.play(-1);
        }
        self.out = setTimeout(() => {
            self.stop();
            restore(true);
            clearTimeout(self.out);
            }, (1000 / 30) * 20);
    }

    principleMotion(autoAnm){
        if(autoAnm){
            this.play(1);
            //this.translucent(autoAnm);
            this.reset(false);
        }else {
            this.reset(true);
            //this.translucent(autoAnm);
        }
    }

    /*
    深拷贝
     */
    deepCopy(obj) {
        var a = JSON.stringify(obj)
        var newobj = JSON.parse(a)
        return newobj
    }
    /*
    添加数组
     */
    pushHideMesh(child) {
        this.meshPosition = {
            name: child.name,
            position: child.position
        }
        this.meshPositions.push(this.deepCopy(this.meshPosition));
        this.rayMesh.push(child);
    }
/*
一键还原
 */
    oneRestore(){
        if(!this.autoAnm){
            this.mixer.setTime(0);
        }
        this.reset(true);
        for (let i = 0; i < this.meshPositions.length; i++) {
            for (let j = 0; j < this.rayMesh.length; j++) {
                if(this.rayMesh[j]&&this.meshPositions[i].name === this.rayMesh[j].name){
                    this.rayMesh[j].position.set(this.meshPositions[i].position.x,this.meshPositions[i].position.y,this.meshPositions[i].position.z);
                }
            }
        }
    }
/*
手动还原
 */
    manualRestore(name){
        for (let i = 0; i < this.meshPositions.length; i++) {
            if(this.meshPositions[i].name === name){
                for (let j = 0; j < this.rayMesh.length; j++) {
                    if(this.rayMesh[j]&&this.rayMesh[j].name === name){
                        this.rayMesh[j].position.set(this.meshPositions[i].position.x,this.meshPositions[i].position.y,this.meshPositions[i].position.z);
                    }
                }
            }
        }
    }
/*
单项隐藏
 */
    hideMesh(name) {
        for (let i = 0; i <= this.rayMesh.length; i++) {
            if (this.rayMesh[i]&&this.rayMesh[i].name === name) {
                this.rayMesh[i].visible = false;
                this.removeMesh.push(this.rayMesh[i]);
                this.rayMesh.splice(i, 1);
            }
        }
    }
/*
全部显示
 */
    showMesh() {
        this.stop();
        for (let i = 0; i < this.removeMesh.length; i++) {
            this.rayMesh.push(this.removeMesh[i]);
        }
        for (let i = 0; i < this.rayMesh.length; i++) {
            this.rayMesh[i].visible = true;
        }
        this.removeMesh = [];

    }
/*
半透明
 */
    translucent(translucentHide) {
        if (translucentHide) {
            for (let i = 0; i < this.rayMesh.length; i++) {
                if (this.rayMesh[i].name === "JXZT257_07") {
                    this.rayMesh[i].material.opacity = 0.3
                    this.rayMesh[i].material.transparent = true;
                }
            }
        } else {
            for (let i = 0; i < this.rayMesh.length; i++) {
                this.rayMesh[i].material.transparent = false;
                this.rayMesh[i].material.opacity = 1
            }
        }
    }
/*
反向显示
 */
    reverseHide() {
        if (this.removeMesh.length > 0) {
            for (let i = 0; i < this.removeMesh.length; i++) {
                this.rayMesh.push(this.removeMesh[i]);
            }
            this.removeMesh = [];
            for (let i = this.rayMesh.length - 1; i >= 0; i--) {
                if (this.rayMesh[i].visible) {
                    this.rayMesh[i].visible = false;
                    this.removeMesh.push(this.rayMesh[i]);
                    this.rayMesh.splice(i, 1);
                } else {
                    this.rayMesh[i].visible = true;
                }
            }
        }
        if (this.removeMesh.length === 0) {
            for (let i = 0; i < this.rayMesh.length; i++) {
                if (this.rayMesh[i].visible) {
                    this.rayMesh[i].visible = false;
                } else {
                    this.rayMesh[i].visible = true;
                }
            }
        }
    }
/*
动画停止
 */
    stop() {
        this.isPaly = false;
    }
/*
播放动画
 */
    play(timeScale) {
        this.mixer.timeScale = timeScale;
        this.isPaly = true;
        /*for (let i = 0; i < this.actions.length; i++) {
            this.actions[i].clampWhenFinished = true;
        }*/
    }
/*
清除动画
 */
    clearAnimate() {
        this.mixer.time = 0;
        for (let i = 0; i < this.actions.length; i++) {
            this.actions[i] && this.actions[i].reset();
        }
    }

    update() {
        let delta = this.clock.getDelta();
        if (this.mixer && this.isPaly) {
            this.mixer.update(delta);
        }
    }

    //清除缓存
    clearCache(scene) {
        if (!scene) return;
        this.dispose(scene, scene);
    }

    //清除模型
    dispose(parent, child) {
        if (child.children.length) {
            let arr = child.children.filter(x => x);
            arr.forEach(a => {
                this.dispose(child, a)
            })
        }

        if (child instanceof THREE.Mesh) {
            if (child.material.map) child.material.map.dispose();
            child.material.dispose();
            child.geometry.dispose();
            child.remove();
            parent.remove(child);
        } else if (child.material) {
            child.material.dispose();
            child.remove();
            parent.remove(child);
        } else if (child instanceof THREE.Group) {
            child.remove();
            parent.remove(child);
        } else if (child.type === "Object3D") {
            child.remove();
            parent.remove(child);
        }
    }

}
